import { Component, Input, OnInit } from '@angular/core';
import { AutoDetail } from '../../../../../models/api/view/claim/details/auto/auto-detail';
import { AutoLoss } from '../../../../../models/api/view/claim/details/auto/auto-loss';
import { BaseComponent } from '../../../../base/base.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { AddressLabelComponent } from '../../../../core/labels/address-label.component';

@Component({
  selector: 'app-loss-au',
  imports: [DetailPanelComponent, DetailItemComponent, AddressLabelComponent],
  template: `
    <div class="tw-flex tw-w-full tw-gap-12 tw-py-8">
      <app-detail-panel [dataSource]="lossData" class="tw-basis-1/3">
        <app-detail-item label="Loss description" name="lossDescription" />
        <app-detail-item label="Address" name="address">
          <ng-template #labelTemplate let-value>
            <app-address-label
              [street1]="value"
              [city]="lossData.city"
              [state]="lossData.state"
              [postalCode]="lossData.zip"
            />
          </ng-template>
        </app-detail-item>
        <app-detail-item label="Report number" name="reportNumber" />
        <app-detail-item
          label="Authority contacted"
          name="authorityContacted"
        />
        <app-detail-item label="Loss payee" name="lossPayee" />
      </app-detail-panel>
    </div>
  `,
  styles: ``,
})
export class LossAuComponent extends BaseComponent implements OnInit {
  @Input() autoDetail: AutoDetail;

  ngOnInit(): void {
    this.view.hideLoading();
  }

  get lossData(): AutoLoss {
    if (!this.autoDetail?.loss) return {};
    return this.autoDetail.loss;
  }
}
